<!--
* @description 走访趋势
* @fileName visitTrend.vue
* @author xuesong
* @date 2022/02/08 10:05:34
!-->
<template>
  <div id="VisitTrend">
    <div id="lineChart" ref="lineChart"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
export default {
  name: 'VisitTrend',
  data() {
    return {
      lineChart: null,
      xdata: [
        '2021年7月',
        '2021年8月',
        '2021年9月',
        '2021年10月',
        '2021年11月',
        '2021年12月',
        '2022年1月',
        '2022年2月'
      ],
      ydata1: [2600, 2359, 2809, 2346, 2435, 2987, 3125, null],
      ydata2: [null, null, null, null, null, null, null, null]
    }
  },
  mounted() {
    this.initChart()
  },
  methods: {
    initChart() {
      const that = this
      this.lineChart = echarts.init(this.$refs.lineChart)
      const option = this.getOption(this.xdata, this.ydata1)
      this.lineChart.setOption(option, true)
      window.addEventListener('resize', () => {
        that.lineChart.resize()
      })
    },
    getOption(xdata, ydata1, ydata2) {
      const options = {
        color: [
          {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: '#02FFFE' // 0% 处的颜色
              },
              {
                offset: 1,
                color: '#D4FFFF' // 100% 处的颜色
              }
            ],
            global: false // 缺省为 false
          },
          '#AADCFF'
        ],
        grid: {
          containLabel: true,
          bottom: '30',
          left: '10'
        },
        tooltip: {
          show: true,
          trigger: 'axis'
        },
        legend: {
          show: true,
          right: '30%',
          top: 30,
          textStyle: {
            color: '#fff',
            fontSize: 12
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: xdata,
          axisLabel: {
            color: 'rgba(255, 255, 255, 0.7)',
            fontSize: 14
          },
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#fff',
              opacity: 0.5
            }
          }
        },
        yAxis: [
          {
            type: 'value',
            name: '单位：次',
            axisLabel: {
              color: 'rgba(255, 255, 255, 0.65)',
              fontSize: 10
            },
            splitLine: {
              lineStyle: {
                type: 'dashed',
                opacity: 0.5,
                width: 0.3
              }
            }
          }
          // {
          //   type: 'value',
          //   name: '单位：%',
          //   axisLabel: {
          //     color: 'rgba(255, 255, 255, 0.65)',
          //     fontSize: 10
          //   },
          //   splitLine: {
          //     lineStyle: {
          //       type: 'dashed',
          //       opacity: 0.5,
          //       width: 0.3
          //     }
          //   }
          // }
        ],
        series: [
          {
            name: '走访次数',
            data: ydata1,
            type: 'bar',
            barWidth: 10,
            backgroundStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: '#02FFFE' // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: '#D4FFFF' // 100% 处的颜色
                  }
                ],
                global: false // 缺省为 false
              }
            }
          }
          // {
          //   name: '好评率',
          //   data: ydata2,
          //   type: 'line',
          //   yAxisIndex: 1,
          //   lineStyle: {
          //     width: 4
          //   },
          //   areaStyle: {
          //     opacity: 0.4,
          //     color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          //       {
          //         offset: 1,
          //         color: 'transparent'
          //       },
          //       {
          //         offset: 0,
          //         color: '#AADCFF'
          //       }
          //     ])
          //   }
          // }
        ]
      }
      return options
    }
  }
}
</script>
<style lang='scss' scoped>
#VisitTrend {
  width: 100%;
  height: 100%;
  #lineChart {
    width: 100%;
    height: 100%;
  }
}
</style>
